type SortingType = "position" | "title" | "points";

const setSorting = (sortType: SortingType): void => {
  const url = new URL(window.location.href);
  const [currentType, currentDirection] = (
    url.searchParams.get("sort_by") || ""
  ).split(" ");

  if (currentType !== sortType || currentDirection === "desc") {
    url.searchParams.set("sort_by", `${sortType} asc`);
  } else {
    url.searchParams.set("sort_by", `${sortType} desc`);
  }

  window.location.href = url.href;
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-ranking-sort").forEach((el) => {
    const sortType = (el as HTMLElement).dataset.sortType as
      | SortingType
      | undefined;
    if (!sortType) {
      return;
    }

    el.addEventListener("click", () => setSorting(sortType));
  });
});
